export default defineNuxtRouteMiddleware((to) => {
  const userStore = useAdminUserStore()

  const path = to.fullPath

  if (!userStore.isAuthenticated) {
    userStore.restore()
  }

  if (!userStore.isAuthenticated) {
    if (path.startsWith('/admin') && !path.startsWith('/admin/login')) {
      return navigateTo('/admin/login')
    }
  }

  return;
});
